import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'
import palette from '../../../styles/palette'
import { MenuProps } from '../../../dtos/menuDtos'

export type StyleMenuProps = MenuProps

/**
 * Sidebar escura do mockup Lovable: `bg-sidebar` sólido, sem sombra colorida,
 * ícones em esmeralda, hover/ativo em `sidebar-accent` e o item "Sair" preso
 * ao rodapé com um fio de 1px acima.
 */
export const useStyles = makeStyles<Theme, StyleMenuProps>((theme) =>
  createStyles({
    containerMenu: {
      height: '100%',
      backgroundColor: colors.purpleDark,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      position: 'fixed',
      zIndex: 3,
      top: 0,
      transition: 'width .25s ease',
      [theme.breakpoints.between(0, 1200)]: {
        position: 'initial',
        width: '100%',
      },
    },
    containerLogo: {
      marginTop: 20,
      marginBottom: 4,
      width: '100%',
      [theme.breakpoints.between(0, 1200)]: {
        marginTop: 2,
      },
    },
    containerMenuItens: {
      marginTop: 4,
      maxHeight: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      '&::-webkit-scrollbar': {
        width: '0.4em',
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.purpleDarkMedium,
        borderRadius: '999px',
      },
    },
    containerMenuTop: {
      width: '100%',
    },
    containerMenuBottom: {
      marginTop: 4,
      width: '100%',
      borderTop: `1px solid rgba(255, 255, 255, 0.06)`,
    },
    colorItemMenu: {
      color: palette.emerald,
    },
    colorItemLogout: {
      color: colors.grayLightest,
    },
    linkContent: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      gap: '12px',
      padding: '14px 20px',
      transition: 'background-color .15s ease',
      '&:hover': {
        backgroundColor: colors.purpleDarkMedium,
      },
    },
    containerSubMenu: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    buttonOpenMenu: {
      backgroundColor: 'transparent',
      width: '100%',
      color: palette.brand,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 12,
      marginTop: 0,
      marginBottom: 4,
    },
    /** Combinada com `buttonOpenMenu` quando a sidebar está expandida. */
    buttonOpenMenuExpanded: {
      justifyContent: 'flex-end',
      paddingRight: 20,
    },
    submenu: {
      paddingRight: 0,
      paddingLeft: 20,
      padding: 5,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: colors.purpleDarkMedium,
      },
    },
    boxAvatarMobile: {
      marginTop: 10,
      marginLeft: 14,
      marginBottom: 8,
    },
  }),
)
